<mat-toolbar class="" color="primary" role="heading">
	<nat-main-menu></nat-main-menu>
	<!-- <h3>Нативи</h3> -->
	<nat-tabs></nat-tabs>
	<!-- <button mat-icon-button>
		<mat-icon>search</mat-icon>
	</button> -->
	<nat-header-right-menu></nat-header-right-menu>
</mat-toolbar>
